import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Fleet from "./pages/Fleet";
import VesselDetail from "./pages/VesselDetail";
import HomeWaters from "./pages/HomeWaters";
import Conservation from "./pages/Conservation";
import PlanningTools from "./pages/PlanningTools";
import FAQ from "./pages/FAQ";
import BookNow from "./pages/BookNow";
import Contact from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fleet" element={<Fleet />} />
          <Route path="/fleet/:slug" element={<VesselDetail />} />
          <Route path="/home-waters" element={<HomeWaters />} />
          <Route path="/conservation" element={<Conservation />} />
          <Route path="/planning-tools" element={<PlanningTools />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
